<template>
    <form-accordion
        name="taxes-insurance"
        section="Taxes and Insurance"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <taxes-multiple
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <insurance-primary
            :insurance="property.insurance"
            :has_coverage="has_coverage"
            :read_only="read_only"
            @updateHasCoverage="updateHasCoverage"
        />

        <insurance-multiple
            v-if="has_coverage"
            :other_insurance_policies="property.insurance.other_insurance_policies"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import TaxesMultiple from './taxes-multiple.vue';
import InsurancePrimary from '../../../buyer/insurance/insurance-primary.vue';
import InsuranceMultiple from '../../../buyer/insurance/insurance-multiple.vue';

export default {
    components: {
        TaxesMultiple,
        InsurancePrimary,
        InsuranceMultiple,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            has_coverage: this.property.insurance.has_coverage,
        }
    },

    methods: {
        updateHasCoverage(value) {
            this.has_coverage = value;
        },
    },
}
</script>
